import {Action} from '@ngrx/store';

export const GET_ALL_MANAGERS = '[Managers] Get All';
export const GET_MANAGER = '[Managers] Get Manager';
export const GET_ALL_MANAGERS_SUCCESS = '[Managers] Get All Success';
export const GET_ALL_MANAGERS_ERROR = '[Managers] Get All Error';
export const GET_MANAGER_SUCCESS = '[Managers] Get Manager Success';
export const GET_MANAGER_ERROR = '[Managers] Get Manager Error';

export const ADD_MANAGER = '[Manager] Add';
export const ADD_MANAGER_SUCCESS = '[Manager] Add Success';
export const ADD_MANAGER_ERROR = '[Manager] Add Error';

export const UPDATE_MANAGER = '[Manager] Update';
export const UPDATE_MANAGER_SUCCESS = '[Manager] Update Success';
export const UPDATE_MANAGER_ERROR = '[Manager] Update Error';


export class GetAllManagers implements Action {
  readonly type = GET_ALL_MANAGERS;
}

export class GetAllManagersSuccess implements Action {
  readonly type = GET_ALL_MANAGERS_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetAllManagersError implements Action {
  readonly type = GET_ALL_MANAGERS_ERROR;

  constructor(public payload: any) {
  }
}

export class GetManager implements Action {
  readonly type = GET_MANAGER;

  constructor(public payload: any) {
  }
}

export class GetManagerSuccess implements Action {
  readonly type = GET_MANAGER_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetManagerError implements Action {
  readonly type = GET_MANAGER_ERROR;

  constructor(public payload: any) {
  }
}

export class AddManager implements Action {
  readonly type = ADD_MANAGER;

  constructor(public payload: any) {
  }
}

export class AddManagerSuccess implements Action {
  readonly type = ADD_MANAGER_SUCCESS;

  constructor(public payload: any) {
  }
}

export class AddManagerError implements Action {
  readonly type = ADD_MANAGER_ERROR;

  constructor(public payload: any) {
  }
}

export class UpdateManager implements Action {
  readonly type = UPDATE_MANAGER;

  constructor(public payload: any) {
  }
}

export class UpdateManagerSuccess implements Action {
  readonly type = UPDATE_MANAGER_SUCCESS;

  constructor(public payload: any) {
  }
}


export class UpdateManagerError implements Action {
  readonly type = UPDATE_MANAGER_ERROR;

  constructor(public payload: any) {
  }
}


export type ManagerAction =
  GetAllManagers
  | GetAllManagersSuccess
  | GetAllManagersError
  | GetManager
  | GetManagerError
  | GetManagerSuccess
  | AddManager
  | AddManagerSuccess
  | AddManagerError
  | UpdateManager
  | UpdateManagerSuccess
  | UpdateManagerError;



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/managers/store/actions/manager.action.ts